export default __webpack_public_path__ + "static/media/dashboard_lofi.be2cc826.jpg";